import React, { Fragment, useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import GenericButton from '../GenericButton';
import { CROSSTAB_PROBABILITIES_MESSAGE } from '../../../constants';

const ProbabilitiesPopover = ({ value, rowData, colData, crosstabviewFlag, handleProbabilitiesEditClick }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const margingTop = crosstabviewFlag ? -10 : 0;
  const useStylesBootstrap = makeStyles(theme => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      border: 'none',
      display: 'flex',
      height: 80,
      width: 235,
      maxWidth: 235,
      boxShadow: theme.shadows[1],
      marginTop: margingTop,
    },
  }));
  const classes = useStylesBootstrap();

  const _handleProbabilitiesEditClick = (rowData, colData) => {
    handleProbabilitiesEditClick(rowData, colData);
    setIsPopoverOpen(false);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  const handleOpen = () => {
    setIsPopoverOpen(true);
  };

  const renderProbabilitiesPopover = () => {
    const ret = (
      <Fragment>
        <div>
          <div className="crosstab-probabilities-popover-label">
            { CROSSTAB_PROBABILITIES_MESSAGE }
          </div>
          <div className="crosstab-popover-probabilities-button">
            <GenericButton
              name="Edit"
              title="Edit"
              btnStyle="button probabilities-edit-btn"
              onBtnClick={() => {
                _handleProbabilitiesEditClick(rowData, colData);
              }}
            />
          </div>
        </div>
      </Fragment>
    );
    return ret;
  };

  return (
    <Tooltip
      open={isPopoverOpen}
      onClose={handleClose}
      onOpen={handleOpen}
      title={renderProbabilitiesPopover(classes)}
      classes={classes} interactive
    >
      <div
        className="crosstab-probabilities-na-label"
      >
        { value }
      </div>
    </Tooltip>
  );
};

ProbabilitiesPopover.propTypes = {
  value: PropTypes.string,
  rowData: PropTypes.Object,
  colData: PropTypes.Object,
  crosstabviewFlag: PropTypes.boolean,
};

export default ProbabilitiesPopover;

